import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const ReasonSelector = ({ onChange, selectedReason, reasons = [] }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      handleChange={onChange}
      fullWidth
      value={selectedReason}
      label={t('¿Cuál es el motivo del rechazo?')}
      placeholder={t('Selecciona un motivo')}
      menuItems={reasons?.map(r => ({ label: t(r.label), value: r.value }))}
    />
  )
}

export default ReasonSelector
